import React from "react";
import { View, TouchableOpacity, Text, StyleSheet } from "react-native";

const LocationItem = ({ onPress = () => {}, item: iparent = {} }) => {
  const { item } = iparent;
  const {
    structured_formatting: { main_text = "", secondary_text = "" } = {},
  } = item || {};

  return (
    <View style={styles.itemView}>
      <TouchableOpacity onPress={onPress}>
        <Text style={styles.primary}>{main_text}</Text>
        <Text style={styles.secondary}>{secondary_text}</Text>
      </TouchableOpacity>
    </View>
  );
};

export default LocationItem;

const styles = StyleSheet.create({
  itemView: {
    backgroundColor: "white",
    marginBottom: 1,
    justifyContent: "center",
    paddingHorizontal: 16,
    width: "100%",
    alignSelf: "center",
    paddingVertical: 11,
  },
  primary: {
    color: "rgba(0,0,0,.8)",
    fontSize: 14,
  },
  secondary: {
    color: "rgba(0,0,0,.36)",
    fontSize: 12,
    marginTop: 3,
  },
});
